import { Component, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreFieldInfoLang } from '@aipb/gulliver/castor/model';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { FieldRepository } from '@aipb/gulliver/castor/data-access';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FacetTreeNode, TreeFacetItem } from '../../model';

export interface TreeFacet {
  fieldId: string;
  value: string;
}

export interface ToggleFacetEvent extends TreeFacet {
  checked: boolean;
  parent?: TreeFacet;
}

@Component({
  selector: 'cat-facet-tree-item',
  standalone: true,
  imports: [CommonModule, MatCheckbox, MatIconModule, MatButtonModule],
  templateUrl: './facet-tree-item.component.html',
  styleUrl: './facet-tree-item.component.scss'
})
export class FacetTreeItemComponent {
  level = input<number>(0);
  coreId = input<string>();
  item = input<FacetTreeNode>();
  field = input<CoreFieldInfoLang>();
  expandedFacetTreeNodes = input<Record<string, boolean>>({});
  checkedFacetTreeNodes = input<Record<string, boolean>>({});

  expand = output<string>();
  collapse = output<string>();
  checkFacet = output<[string[], boolean]>();

  private fieldRepository = inject(FieldRepository);

  onToggleExpanded(field: CoreFieldInfoLang, id: string) {
    if (this.isExpanded(id)) {
      this.collapse.emit(id);
    } else {
      this.expand.emit(id);
    }
  }

  getRegisterField(key: string) {
    return this.fieldRepository.getRegisterField(this.coreId(), key);
  }

  isExpanded(id: string) {
    const expandedFacetTreeNodes = this.expandedFacetTreeNodes();

    return id in expandedFacetTreeNodes ? expandedFacetTreeNodes[id] : false;
  }

  onCheckedChange(event: MatCheckboxChange, item: TreeFacetItem) {
    this.checkFacet.emit([[item.id], event.checked]);
    this.expand.emit(item.id);
  }

  onCheckFacet(data: [string[], boolean], i: TreeFacetItem) {
    this.checkFacet.emit([[i.id, ...data[0]], data[1]]);
  }
}
